import * as ko from 'knockout';

import { I18nText } from '../i18n_text';
import { ClientTypeData } from '../api/client_types';

export class ClientType {
  id = ko.observable<string>(null);
  nameJson = ko.observable<I18nText>().extend({
    i18nTextRequired: true,
    serverError: true,
  });

  constructor(data?: ClientTypeData) {
    if (data) {
      this.id(data.id);
      this.nameJson(data.name_json);
    }
  }

  toData(): ClientTypeData {
    return {
      id: this.id(),
      name_json: this.nameJson(),
    };
  }
}
